/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtistAliasCreateSourceIdsSpotifyInner
 */
export interface ArtistAliasCreateSourceIdsSpotifyInner {
    /**
     * 
     * @type {string}
     * @memberof ArtistAliasCreateSourceIdsSpotifyInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistAliasCreateSourceIdsSpotifyInner
     */
    originalName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistAliasCreateSourceIdsSpotifyInner
     */
    valid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistAliasCreateSourceIdsSpotifyInner
     */
    rejected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistAliasCreateSourceIdsSpotifyInner
     */
    approved: boolean;
}

/**
 * Check if a given object implements the ArtistAliasCreateSourceIdsSpotifyInner interface.
 */
export function instanceOfArtistAliasCreateSourceIdsSpotifyInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "originalName" in value;
    isInstance = isInstance && "valid" in value;
    isInstance = isInstance && "rejected" in value;
    isInstance = isInstance && "approved" in value;

    return isInstance;
}

export function ArtistAliasCreateSourceIdsSpotifyInnerFromJSON(json: any): ArtistAliasCreateSourceIdsSpotifyInner {
    return ArtistAliasCreateSourceIdsSpotifyInnerFromJSONTyped(json, false);
}

export function ArtistAliasCreateSourceIdsSpotifyInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistAliasCreateSourceIdsSpotifyInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'originalName': json['original_name'],
        'valid': json['valid'],
        'rejected': json['rejected'],
        'approved': json['approved'],
    };
}

export function ArtistAliasCreateSourceIdsSpotifyInnerToJSON(value?: ArtistAliasCreateSourceIdsSpotifyInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'original_name': value.originalName,
        'valid': value.valid,
        'rejected': value.rejected,
        'approved': value.approved,
    };
}

